module.exports = __webpack_public_path__ + "static/media/spot4.4bf58847.webp";